import moment from "moment"
import React, { useCallback, useState } from "react"
import { StyleSheet, Text, View } from "react-native"
import { useMediaQuery } from "react-responsive"

import Base from "../../../base"
import base from "../../../base"
import { AppButton } from "../../common"
import Gap from "../../common/Gap"
import TimePicker from "../../common/TimePicker"

export default function TimeSlot(props) {
  const [from, setFrom] = useState(
    props.timeslot ? new Date(props.timeslot.from) : new Date(),
  )
  const [to, setTo] = useState(
    props.timeslot ? new Date(props.timeslot.to) : new Date(),
  )
  const isTablet = useMediaQuery(base.constants.tablet)

  const onCommit = useCallback(() => {
    let fromDate = moment(from)
      .set({ year: 1989, month: 3, day: 19, second: 0 })
      .toISOString(true)
    let toDate = moment(to)
      .set({ year: 1989, month: 3, day: 19, second: 0 })
      .toISOString(true)
    const timeslot = props.timeslot ?? { from: fromDate, to: toDate }
    props.onCommit(timeslot)
  }, [from, props, to])

  const onDateChanged = useCallback(
    key => date => {
      if (key === "to") {
        setTo(date)
        if (date < from) {
          setFrom(date)
        }
      } else {
        setFrom(date)
        if (date > to) {
          setTo(date)
        }
      }
    },
    [from, to],
  )

  return (
    <View style={styles.main}>
      <TimePicker
        disabled={!!props.timeslot}
        withBorder={!props.timeslot}
        value={from}
        onChange={onDateChanged("from")}
      />
      <Text style={[styles.dash, !!isTablet && styles.dash_md]}>-</Text>
      <TimePicker
        disabled={!!props.timeslot}
        withBorder={!props.timeslot}
        value={to}
        onChange={onDateChanged("to")}
      />
      <Gap size={20} horizontal />
      <AppButton
        style={styles.button}
        title={props.timeslot ? "Remove" : "Add"}
        onPress={onCommit}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    marginBottom: 12,
  },

  dash: {
    fontFamily: Base.fonts.appRegular,
    fontSize: 30,
    marginTop: -5,
    width: 50,
    textAlign: "center",
  },

  dash_md: {
    width: 30,
  },

  button: {
    height: 40,
    width: 110,
    borderRadius: 20,
    shadowOpacity: 0.0,
  },
})
